import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import clsx from 'clsx';
import { WEB_PATHS } from '@app/constants/paths';
const { PAGE_CONTACT } = WEB_PATHS;

const HubspotEmbeddedForm = ({ formId, fallbackUrl, children, className, userEmail }) => {
  const [ modalIsOpen, setIsOpen ] = useState(false);
  const [ formCreated, setFormCreated ] = useState(false);
  const modalClassName = useMemo(() => clsx('modal', modalIsOpen && 'is-active'), [ modalIsOpen ]);
  const formContainerIdRef = useRef(`hubspotForm-${ Math.random().toString(36).slice(2) }`);
  const formContainerId = formContainerIdRef.current;

  const handleContactForm = () => {
    if (formCreated) {
      setIsOpen(true);
      return;
    }

    if (formId) {
      openHubspotForm(formId);
      setFormCreated(true);
      setIsOpen(true);
    }

    if (!formId) {
      window.location.href = fallbackUrl || PAGE_CONTACT;
    }
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const openHubspotForm = useCallback((id) => {
    if (window.hbspt?.forms && id) {
      window.hbspt.forms.create({
        region: 'eu1',
        portalId: process.env.REACT_APP_HUBSPOT_PORTAL_ID,
        formId: id,
        target: `#${ formContainerId }`,
        onFormReady: (form) => {
          setTimeout(() => {
            // Add the prescriber to the form as a hidden input.
            // This is used in HubSpot automation to determine
            // which person at SielBleu should be contacted.
            const prescriber = document.createElement('input');
            prescriber.type = 'hidden';
            prescriber.name = 'prescriber';
            prescriber.value = 'mcsb';
            form.appendChild(prescriber);

            const emailInput = form.querySelector('input[name="email"]');
            if (emailInput) {
              emailInput.required = false;
              emailInput.removeAttribute('required');
              if (userEmail) {
                emailInput.value = userEmail;
                emailInput.dispatchEvent(new Event('input', { bubbles: true }));
                emailInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }, 500);
        },
      });
    }
  }, [ formContainerId, userEmail ]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
    document.body.appendChild(script);
  }, []);

  const modal = (
    <div className={ modalClassName }>
      <div className="modal-background" onClick={ closeModal }></div>
      <div className="modal-content box has-background-white p-5">
        <button className="delete is-large" aria-label="close" onClick={ closeModal }></button>
        <div id={ formContainerId } className="pt-0"></div>
      </div>
    </div>
  );

  return (
    <>
      <a href="" className={ className } onClick={ (event) => {
        event.preventDefault();
        handleContactForm();
      } }>
        { children }
      </a>
      { createPortal(modal, document.body) }
    </>
  );
};

export default HubspotEmbeddedForm;
